export enum TestResultState {
    PASSED,
    WARNING,
    FAILED
}
